import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sharedFile",
  "use": "icon-sharedFile-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-sharedFile\">\n<path class=\"st0\" d=\"M71.1,30.5l17.1,19.2l2.3,2.6h89.2v117.3H20.3V30.5H71.1 M74.6,22.7H12.5v154.7h175V44.5H94L74.6,22.7z\n\t M187.5,66.7h-175v7.8h175V66.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sharedFile.svg
// module id = a8qH
// module chunks = 183